import {FILTERS_ID_SEPARATOR, FILTER_PRICE_KEY} from '../../constants/filterConstants';

const reduceValueDouble = (pVal, oVal, key = 'value')=> {
    const array = [...pVal];
    oVal.forEach((vo) => {
        if(array.some((v) => v[key] === vo[key]) && !vo['uniqueId'].startsWith(FILTER_PRICE_KEY + FILTERS_ID_SEPARATOR)) {
          const index = pVal.findIndex((v) => v[key] === vo[key]);
          array[index] = {
            value: vo[key],
            uniqueId: vo['uniqueId'],
            children: reduceValueDouble(array[index].children, vo.children)
          };
        } else {
          array.push(vo);
        }
    });

    return array;
};

const mergeDeepFilters = (...objects) => {
    const isObject = obj => obj && typeof obj === 'object';

    return objects.reduce((prev, obj) => {
        Object.keys(obj).forEach(key => {
            const pVal = prev[key];
            const oVal = obj[key];

            if (Array.isArray(pVal) && Array.isArray(oVal)) {
              prev[key] = reduceValueDouble(pVal, oVal);
            }
            else if (isObject(pVal) && isObject(oVal)) {
              prev[key] = mergeDeepFilters(pVal, oVal);
            }
            else {
              prev[key] = oVal;
            }
        });

        return prev;
    }, {});
};

export {mergeDeepFilters, reduceValueDouble};
